<template>
  <div class="clearfix" v-if="!pageLoad">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="pageLoad" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">

    <div class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10">
      <div class="position-relative" style="min-width: 220px; max-width: 300px; flex: 1 1 auto;">
       <input 
              type="text" 
              v-model="searchQuery" 
              @input="filterOperators" 
              class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
              :placeholder="$t('operators.searchPlaceholder')"
            />
      </div>
      <div class="d-flex align-items-center">
         <button
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#companyModal"
            style="background-color: #EB9355;"
            @click="initField"
            v-if="current_permissions('create_operator')"
          >
            {{ $t('operators.addOperator') }}
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          </button>
      </div>
    </div>

    
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('operators.code') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('operators.operator') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('operators.mno') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('operators.provider') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('operators.operationType') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('operators.paymentMethod') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('operators.country') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('operators.countryCode') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('operators.phoneCode') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('operators.phoneMask') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('operators.activationDelay') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('operators.isOtpRequired') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('operators.description') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('operators.status') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="displayedOperators.length === 0">
              <td colspan="15" class="text-center py-5 text-muted">
                {{ $t('operators.noResults') }}
              </td>
            </tr>
            <tr v-for="(operator) in displayedOperators" :key="operator.id">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ operator.code }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ operator.name === null ? '' : operator.name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ operator.mnoName === null ? '' : operator.mnoName }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ operator.provider && operator.provider.name ? operator.provider.name : '' }}
              </td>
              <td v-if="operator.operationType!==null" class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span v-if="operator.operationType==='1'">{{ $t('operators.payin') }}</span>
                <span v-if="operator.operationType==='2'">{{ $t('operators.payout') }}</span>
                <span v-if="operator.operationType==='3'">{{ $t('operators.payinPayout') }}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ operator.paymentMethod === null ? '' : operator.paymentMethod }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ operator.countryName === null ? '' : operator.countryName }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ operator.countryCode === null ? '' : operator.countryCode }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ operator.phoneCode === null ? '' : operator.phoneCode}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ operator.phoneMask === null ? '' : operator.phoneMask }}
              </td>
              <!-- Activation Delay - checkOnlyAfterTimeout -->
              <td class="shadow-none lh-1 fw-medium">
                <span class="badge text-outline-success" v-if="operator.checkOnlyAfterTimeout === true">
                  {{ $t('operators.active') }}
                </span>
                <span class="badge text-outline-danger" v-else>
                  {{ $t('operators.inactive') }}
                </span>
              </td>
              <!-- Is OTP Required -->
              <td class="shadow-none lh-1 fw-medium">
                <span class="badge text-outline-success" v-if="operator.isOtpRequired === true">
                  {{ $t('operators.active') }}
                </span>
                <span class="badge text-outline-danger" v-else>
                  {{ $t('operators.inactive') }}
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ operator.description === null ? '' : operator.description }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span class="badge text-outline-success" v-if="operator.status==='ACTIVE'">{{ $t('operators.active') }}</span>
                <span class="badge text-outline-danger" v-if="operator.status==='INACTIVE'">{{ $t('operators.inactive') }}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" v-if="current_permissions('switch_operator')" @click="switchOperator(operator.code)">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        <span>{{ $t('operators.switch') }}</span>
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" v-if="current_permissions('status_operator')" @click="changeStatus(operator.status,operator.code)">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        <span v-if="operator.status==='ACTIVE'">{{ $t('operators.deactivate') }}</span>
                        <span v-if="operator.status==='INACTIVE'">{{ $t('operators.activate') }}</span>
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#companyModal" @click="showOperator(operator.code)" v-if="current_permissions('edit_operator')">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        <span class="">{{ $t('operators.edit') }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="total>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p class="mb-0 text-paragraph">
          {{ $t('operators.showing') }} <span class="fw-bold">{{ displayedOperators.length > 0 ? Math.min((page-1)*10 + 1, total) : 0 }}</span> 
          {{ $t('operators.to') }} <span class="fw-bold">{{ Math.min(page*10, total) }}</span> 
          {{ $t('operators.outOf') }}
          <span class="fw-bold">{{ total }}</span> {{ $t('operators.results') }}
        </p>
        <nav class="mt-15 mt-md-0" v-if="numPages > 1">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="goToPage(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in paginationPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="goToPage(numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="goToPage(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Create/Edit Operator -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="save">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ edit == 0 ? $t('operators.addOperator') : $t('operators.editOperator') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('operators.name') }}</label>
                  <div>
                    <input v-model="formValues.name" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('operators.namePlaceholder')" @blur="validate('name')" @keyup="validate('name')" :class="{ 'is-invalid': errorsBis['name'] }" />
                    <span class="invalid-feedback">{{ errorsBis['name']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('operators.mno') }}</label>
                  <div>
                    <input v-model="formValues.mnoName" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('operators.mnoPlaceholder')" @blur="validate('mnoName')" @keyup="validate('mnoName')" :class="{ 'is-invalid': errorsBis['mnoName'] }" />
                    <span class="invalid-feedback">{{ errorsBis['mnoName']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('operators.status') }}</label>
                  <select name="status" id="status" class="form-select fs-md-15 text-black shadow-none" v-model="selectedStatus" required>
                    <option value="">{{ $t('operators.select') }}</option>
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="INACTIVE">INACTIVE</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('operators.paymentMethod') }}</label>
                  <div>
                    <input v-model="formValues.paymentMethod" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('operators.paymentMethodPlaceholder')" @blur="validate('paymentMethod')" @keyup="validate('paymentMethod')" :class="{ 'is-invalid': errorsBis['paymentMethod'] }" />
                    <span class="invalid-feedback">{{ errorsBis['paymentMethod']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('operators.phoneCode') }}</label>
                  <div>
                    <input v-model="formValues.phoneCode" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('operators.phoneCodePlaceholder')" @blur="validate('phoneCode')" @keyup="validate('phoneCode')" :class="{ 'is-invalid': errorsBis['phoneCode'] }" />
                    <span class="invalid-feedback">{{ errorsBis['phoneCode']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('operators.operationType') }}</label>
                  <select name="operationType" id="operationType" class="form-select fs-md-15 text-black shadow-none" v-model="selectedOperationType" required>
                    <option value="">{{ $t('operators.select') }}</option>
                    <option value="1">{{ $t('operators.payin') }}</option>
                    <option value="2">{{ $t('operators.payout') }}</option>
                    <option value="3">{{ $t('operators.payinPayout') }}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('operators.provider') }}</label>
                  <select name="provider" id="provider" class="form-select fs-md-15 text-black shadow-none" v-model="selectedProvider" required>
                    <option value="">{{ $t('operators.select') }}</option>
                    <option v-for="provider in providers" :value="provider.code" :key="provider.code"> {{ provider.name }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('operators.activationDelay') }}</label>
                  <select name="checkOnlyAfterTimeout" id="checkOnlyAfterTimeout" class="form-select fs-md-15 text-black shadow-none" v-model="selectedCheckOnlyAfterTimeout" required>
                    <option value="">{{ $t('operators.select') }}</option>
                    <option :value="false">{{ $t('operators.inactive') }}</option>
                    <option :value="true">{{ $t('operators.active') }}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('operators.phoneMask') }}</label>
                  <div>
                    <input v-model="formValues.phoneMask" type="number" min="0" max="15" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('operators.phoneMaskPlaceholder')" @blur="validate('phoneMask')" @keyup="validate('phoneMask')" :class="{ 'is-invalid': errorsBis['phoneMask'] }" />
                    <span class="invalid-feedback">{{ errorsBis['phoneMask']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('operators.country') }}</label>
                  <select name="country" id="country" class="form-select fs-md-15 text-black shadow-none" v-model="selectedCountry" required>
                    <option value="">{{ $t('operators.select') }}</option>
                    <option v-for="country in countries" :value="country.countryCode" :key="country.code"> {{ country.name }}</option>
                  </select>
                </div>
              </div>
              <!-- Champs : isOtpRequired et otpInputMask -->
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('operators.isOtpRequired') }}</label>
                  <select name="isOtpRequired" id="isOtpRequired" class="form-select fs-md-15 text-black shadow-none" v-model="selectedIsOtpRequired" required>
                    <option value="">{{ $t('operators.select') }}</option>
                    <option :value="false">{{ $t('operators.inactive') }}</option>
                    <option :value="true">{{ $t('operators.active') }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('operators.otpInputMask') }}</label>
                  <div>
                    <input v-model="formValues.otpInputMask" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('operators.otpInputMaskPlaceholder')" @blur="validate('otpInputMask')" @keyup="validate('otpInputMask')" :class="{ 'is-invalid': errorsBis['otpInputMask'] }" />
                    <span class="invalid-feedback">{{ errorsBis['otpInputMask']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('operators.description') }}</label>
                  <div>
                    <input v-model="formValues.description" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('operators.descriptionPlaceholder')" @blur="validate('description')" @keyup="validate('description')" :class="{ 'is-invalid': errorsBis['description'] }" />
                    <span class="invalid-feedback">{{ errorsBis['description']}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" v-if="current_permissions('create_operator', 'edit_operator')">
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ edit == 0 ? $t('operators.save') : $t('operators.edit') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, reactive, inject, computed } from "vue";
import axios from 'axios';
import router from '../../router/index'
import { useI18n } from "vue-i18n";
import { showToast, checkSessionValidate } from "../../utils/function";
import { current_permissions } from '../../utils/permission';
import { useRoute } from 'vue-router'
import * as yup from 'yup';
import { Country, Fee, Operator, Organization, TypeFree, Provider } from "@/utils/Model";

const backApi = inject('back');
const page = ref(1);
const total = ref(0);
const pagesLeft = ref(0);
const currentPage = ref(0);
const numPages = ref(0);
let edit = 0;
let itemCode = '';
let code: string | null = '';
const selectedOrganization = ref(code);
const selectedOperator = ref('');
const selectedCountry = ref('');
const selectedTypeFee = ref('');
const selectedMode = ref('');
const btnLoad = ref(true);
const { t } = useI18n();

const selectedStatus = ref('');
const selectedPaymentMethod = ref('');
const selectedOperationType = ref('');
const selectedCheckOnlyAfterTimeout = ref<boolean | string>('');
const selectedProvider = ref('');
const selectedIsOtpRequired = ref<boolean | string>('');

let countryCode = ''
let countryName = ''

const loader = ref(false);

let token: string | null = localStorage.getItem('login_token');

const countries = ref(new Array<Country>());
const fees = ref(new Array<Fee>());
const organizations = ref(new Array<Organization>());
const operators = ref(new Array<Operator>());
const providers = ref(new Array<Provider>());
const typefees = ref(new Array<TypeFree>());
let operatorsTemp = new Array<Operator>();
let countriesTemp = new Array<Country>();

// Variables pour la recherche
const searchQuery = ref('');
const filteredOperators = ref(new Array<Operator>());

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorsBis = { 
  'name': '', 
  'valeur': '', 
  'mnoName': '', 
  'description': '', 
  'otpInputMask': '',
  'paymentMethod': '',
  'phoneCode': '',
  'phoneMask': ''
};
const pageLoad = ref(false);

const formValues = reactive({
  valeur: "",
  name: "",
  mnoName: "",
  description: "",
  phoneCode: "",
  phoneMask: 0,
  paymentMethod: "",
  otpInputMask: ""
});

const schema = yup.object({
  name: yup.string().required('Le nom de l\'operateur est requis'),
  mnoName: yup.string().required('Le nom du mno est requis'),
  description: yup.string().required('La description est requise'),
  phoneCode: yup.string().required('L\'indice telephonique est requis'),
  phoneMask: yup.string().required('Le masque telephonique est requis'),
  paymentMethod: yup.string().required('La methode de paiement est requise'),
  otpInputMask: yup.string().nullable(),
});

// Computed pour les opérateurs affichés avec pagination
const displayedOperators = computed(() => {
  const dataToUse = searchQuery.value ? filteredOperators.value : operatorsTemp;
  const start = (page.value - 1) * 10;
  const end = start + 10;
  return dataToUse.slice(start, end);
});

// Computed pour les pages de pagination
const paginationPages = computed(() => {
  const pages = [];
  const totalPages = numPages.value;
  const current = page.value;
  
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    if (current <= 3) {
      for (let i = 1; i <= 5; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(totalPages);
    } else if (current >= totalPages - 2) {
      pages.push(1);
      pages.push('...');
      for (let i = totalPages - 4; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      pages.push('...');
      for (let i = current - 1; i <= current + 1; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(totalPages);
    }
  }
  return pages;
});

const initField = () => {
  formValues.name = '';
  formValues.mnoName = "";
  formValues.description = "";
  formValues.phoneCode = "";
  formValues.phoneMask = 0;
  formValues.paymentMethod = "";
  formValues.otpInputMask = "";
  itemCode = '';
  edit = 0;
  selectedCountry.value = '';
  selectedOperationType.value = '';
  selectedProvider.value = '';
  selectedCheckOnlyAfterTimeout.value = '';
  selectedIsOtpRequired.value = '';
  selectedStatus.value = '';
  countryCode = '';
  countryName = '';
  errorId.value = '';
  errors.value = '';
}

function handleCheckOnlyAfterTimeoutChange(event) {
  const value = event.target.value;
  if (value === 'true') {
    selectedCheckOnlyAfterTimeout.value = true;
  } else if (value === 'false') {
    selectedCheckOnlyAfterTimeout.value = false;
  } else {
    selectedCheckOnlyAfterTimeout.value = '';
  }
}

function handleOperationTypeChange(event) {
  selectedOperationType.value = event.target.value;
}

function handleProviderChange(event) {
  selectedProvider.value = event.target.value;
}

function handleIsOtpRequiredChange(event) {
  const value = event.target.value;
  if (value === 'true') {
    selectedIsOtpRequired.value = true;
  } else if (value === 'false') {
    selectedIsOtpRequired.value = false;
  } else {
    selectedIsOtpRequired.value = '';
  }
}

function handleCountryChange(event) {
  var i = 0;
  while (i < countriesTemp.length) {
    if (countriesTemp[i].countryCode == event.target.value) {
      selectedCountry.value = countriesTemp[i].code;
      countryCode = countriesTemp[i].countryCode;
      countryName = countriesTemp[i].name;
    }
    i++;
  }
  var j = 0;
  var operatorArr = new Array<Operator>();
  while (j < operatorsTemp.length) {
    if (operatorsTemp[j].countryCode == event.target.value) {
      operatorArr.push(operatorsTemp[j]);
    }
    j++;
  }
  operators.value = operatorArr;
}

// Méthode utilitaire pour obtenir le label du type d'opération
const getOperationTypeLabel = (operationType: string) => {
  switch(operationType) {
    case '1': return t('operators.payin');
    case '2': return t('operators.payout');
    case '3': return t('operators.payinPayout');
    default: return '';
  }
};

// Méthode pour filtrer les opérateurs
const filterOperators = () => {
  const query = searchQuery.value.toLowerCase().trim();
  
  if (!query) {
    filteredOperators.value = [...operatorsTemp];
    updatePagination();
    return;
  }

  filteredOperators.value = operatorsTemp.filter(operator => {
    return (
      (operator.code && operator.code.toLowerCase().includes(query)) ||
      (operator.name && operator.name.toLowerCase().includes(query)) ||
      (operator.mnoName && operator.mnoName.toLowerCase().includes(query)) ||
      (operator.provider && operator.provider.name && operator.provider.name.toLowerCase().includes(query)) ||
      (operator.paymentMethod && operator.paymentMethod.toLowerCase().includes(query)) ||
      (operator.countryName && operator.countryName.toLowerCase().includes(query)) ||
      (operator.countryCode && operator.countryCode.toLowerCase().includes(query)) ||
      (operator.phoneCode && operator.phoneCode.toLowerCase().includes(query)) ||
      (operator.phoneMask && operator.phoneMask.toString().includes(query)) ||
      (operator.description && operator.description.toLowerCase().includes(query)) ||
      (operator.status && operator.status.toLowerCase().includes(query)) ||
      (operator.operationType && getOperationTypeLabel(operator.operationType).toLowerCase().includes(query))
    );
  });

  updatePagination();
};

// Méthode pour effacer la recherche
const clearSearch = () => {
  searchQuery.value = '';
  filteredOperators.value = [...operatorsTemp];
  updatePagination();
};

// Mettre à jour la pagination avec les résultats filtrés
const updatePagination = () => {
  const dataToDisplay = searchQuery.value ? filteredOperators.value : operatorsTemp;
  total.value = dataToDisplay.length;
  const itemsPerPage = 10;
  numPages.value = Math.ceil(total.value / itemsPerPage);
  if (page.value > numPages.value && numPages.value > 0) {
    page.value = numPages.value;
  } else if (numPages.value === 0) {
    page.value = 1;
  }
};

// Aller à une page spécifique
const goToPage = (pageNumber: number) => {
  if (pageNumber !== page.value && pageNumber >= 1 && pageNumber <= numPages.value) {
    page.value = pageNumber;
  }
};

const getFees = (arg = 1) => {
  // Cette méthode est conservée mais n'est plus utilisée pour la pagination
  page.value = arg;
  // Ne pas refaire d'appel API car on filtre côté client
};

const getOrganizations = () => {
  axios.get(backApi + '/secure/organizations/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      organizations.value = response.data;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const fetchProvidersPage = (targetPage: number) => {
  const url = `${backApi}/secure/providers/?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const getProviders = async () => {
  try {
    const first = await fetchProvidersPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchProvidersPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    providers.value = collected;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const getTypeFees = () => {
  axios.get(backApi + '/secure/typefees/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      typefees.value = response.data;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const getCountries = () => {
  axios.get(backApi + '/secure/countries/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      countriesTemp = response.data;
      countries.value = response.data;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const fetchOperatorsPage = (targetPage: number) => {
  const url = `${backApi}/secure/operators/?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const getOperators = async () => {
  try {
    const first = await fetchOperatorsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchOperatorsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    operatorsTemp = collected;
    filteredOperators.value = [...collected];
    updatePagination();
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const switchOperator = (code) => {
  axios.post(`${backApi}/secure/operators/switch`, {
    code: code
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    showToast("Operation reussie", "green");
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
      showToast(error.response.data.message, "red");
    }
  });
}

const changeStatus = (status, code) => {
  axios.put(`${backApi}/secure/operators/${code}/status`, {
    code: code,
    status: (status == 'ACTIVE') ? 'INACTIVE' : 'ACTIVE'
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    router.go();
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const showOperator = (code) => {
  axios.get(backApi + '/secure/operators/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      formValues.name = response.data.name || '';
      formValues.mnoName = response.data.mnoName || '';
      formValues.paymentMethod = response.data.paymentMethod || '';
      formValues.phoneCode = response.data.phoneCode || '';
      formValues.description = response.data.description || '';
      formValues.phoneMask = response.data.phoneMask || 0;
      formValues.otpInputMask = response.data.otpInputMask || '';

      selectedStatus.value = response.data.status || '';
      selectedOperationType.value = response.data.operationType || '';
      selectedProvider.value = response.data.provider?.code || '';
      selectedCountry.value = response.data.countryCode || '';
      
      selectedCheckOnlyAfterTimeout.value = response.data.checkOnlyAfterTimeout === true;
      selectedIsOtpRequired.value = response.data.isOtpRequired === true;

      countryCode = response.data.countryCode || '';
      countryName = response.data.countryName || '';

      itemCode = response.data.code;
      edit = 1;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          showToast("Erreur lors du chargement de l'opérateur", "red");
        }
      }
    });
}

const save = () => {
  if (edit == 0) {
    storeOperator()
  } else {
    updateProvidor()
  }
}

const storeOperator = async () => {
  try {
    schema.validateSync(formValues);

    const response = await axios.post(
      `${backApi}/secure/operators/new`,
      {
        name: formValues.name,
        mnoName: formValues.mnoName,
        status: selectedStatus.value,
        paymentMethod: formValues.paymentMethod,
        countryCode: countryCode,
        countryName: countryName,
        phoneCode: formValues.phoneCode,
        operationType: selectedOperationType.value,
        description: formValues.description,
        phoneMask: formValues.phoneMask,
        provider: selectedProvider.value,
        checkOnlyAfterTimeout: selectedCheckOnlyAfterTimeout.value === true,
        isOtpRequired: selectedIsOtpRequired.value === true,
        otpInputMask: formValues.otpInputMask || null
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      }
    );

    if (response.status === 200) {
      showToast(
        "Operateur " + formValues.name.toLowerCase() + " enregistré avec succès",
        "green"
      );

      initField();

      setTimeout(() => {
        router.go();
      }, 1000);
    }

  } catch (error) {

    console.error("ERREUR COMPLETE :", error);

    // Erreur Yup
    if (error?.name === "ValidationError") {
      errors.value = error.message;
      showToast(error.message, "red");
      return;
    }

    // Erreur API
    if (error?.response) {
      console.error("Status API :", error.response.status);
      console.error("Data API :", error.response.data);

      if (error.response.status === 401) {
        router.push('/');
        return;
      }

      errorId.value = error.response.data?.errorId || '';
      errors.value =
        error.response.data?.message || "Une erreur est survenue";

      showToast(errors.value, "red");
      return;
    }

    // Autre erreur JS
    errors.value = error?.message || "Une erreur inattendue est apparue";
    showToast(errors.value, "red");
  }
};

const updateProvidor = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);
    
    axios.put(`${backApi}/secure/operators/${itemCode}/edit`, {
      name: formValues.name,
      description: formValues.description,
      mnoName: formValues.mnoName,
      status: selectedStatus.value,
      paymentMethod: formValues.paymentMethod,
      countryCode: countryCode,
      countryName: countryName,
      phoneCode: formValues.phoneCode,
      operationType: selectedOperationType.value,
      phoneMask: formValues.phoneMask,
      provider: selectedProvider.value,
      checkOnlyAfterTimeout: selectedCheckOnlyAfterTimeout.value === true,
      isOtpRequired: selectedIsOtpRequired.value === true,
      otpInputMask: formValues.otpInputMask || null,
      code: itemCode,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Modification effectuée avec succès", "green");
        setTimeout(() => {
          router.go();
        }, 1000);
      }
    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId || '';
          errors.value = error.response.data.message || 'Une erreur est survenue';
          showToast(errors.value, "red");
        }
      }
    });
  } catch (error) {
    errors.value = "Une erreur inattendue est apparue";
    showToast(errors.value, "red");
    btnLoad.value = true;
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

onMounted(async () => {
  checkSessionValidate(1)
  const route = useRoute();
  code = route.params.id;
  getFees();
  await getOperators();
  await getProviders();
  getOrganizations();
  getTypeFees();
  getCountries();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)
});
</script>